import {
  CommonModule,
  CurrencyPipe,
  DatePipe,
  DecimalPipe
} from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule
} from 'ngx-perfect-scrollbar';
import { ToastrModule } from 'ngx-toastr';
import { ButtonModule } from 'primeng/button';
import { environment } from './../environments/environment';
import { APPRoutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthorizatedGuard } from './authentication/auth.guard';
import { ErrorInterceptor } from './core/interceptors/errorInterceptor';
import { JwtInterceptor } from './core/interceptors/tokenInterceptor';
import { FormPipe } from './core/pipes/base/form-pipe';
import { NavigationService } from './core/services/components/navigation.service';
import { AppStoreModule } from './core/store/app-store.module';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { FullHorizontalComponent } from './layouts/fullHorizontal/fullHorizontal.component';
import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { ShareModule } from './shared/share.module';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { UtilitiesModule } from './shared/utilities.module';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
registerLocaleData(localeEs, 'es');
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 1,
  wheelPropagation: true,
  minScrollbarLength: 20,
};

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    FullHorizontalComponent,
    BlankComponent,
    NavigationComponent,
    SidebarComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    RouterModule.forRoot(APPRoutes),
    PerfectScrollbarModule,
    ButtonModule,
    UtilitiesModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
    ShareModule,
    CommonModule,
    AppStoreModule,
    NgxSpinnerModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },

    FormPipe,
    DatePipe,
    {
      provide: LOCALE_ID,
      useValue: 'es',
    },
    CurrencyPipe,
    DecimalPipe,

    NavigationService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    AuthorizatedGuard,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  ],

  bootstrap: [AppComponent],
})
export class AppModule { }
